import React from 'react';
import Image, { StaticImageData } from 'next/image';

interface IconProps {
  className?: string;
  src: string | StaticImageData;
  alt?: string;
  width?: number;
  height?: number;
}

export const Icon: React.FC<IconProps> = ({ className, src, alt, width, height }) => {
  return (
    <div className={`${className}`}>
      <Image src={src} width={width} height={height} alt={`${alt}`} className="rounded-[34px]" />
    </div>
  );
};
